import { render, staticRenderFns } from "./EditNilaiRenang.vue?vue&type=template&id=68f24c6d"
import script from "./EditNilaiRenang.vue?vue&type=script&lang=js"
export * from "./EditNilaiRenang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports